import { useSelector, useDispatch } from "react-redux";
import { logout } from "../features/authSlice";
import { useNavigate } from "react-router-dom";
import { logoutMerchantUser } from "../api/userAuth";

const ForceLogoutModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const show = useSelector((state) => state.auth.forceLogout);


   const handleOk = async () => {
    try {
      // 🔥 Call backend logout API
      await logoutMerchantUser();
    } catch (err) {
      console.error("Logout API failed", err);
    }

    // 🔥 Clear frontend auth
    dispatch(logout());

    // 🔥 Hard redirect (fast & safe)
    window.location.replace("/");
  };


  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center">

      {/* 🔥 Blur Background Overlay */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm pointer-events-auto"></div>

      {/* Popup Box */}
      <div className="relative bg-white dark:bg-slate-900 text-black dark:text-white rounded-xl shadow-2xl p-6 w-[90%] max-w-md z-[10000] animate-scaleIn">
        <h2 className="text-xl font-bold text-red-600">Session Expired</h2>
        <p className="mt-2 text-sm opacity-80">
          You have been logged out from another device.
        </p>

        <button
          onClick={handleOk}
          className="mt-4 w-full bg-red-600 hover:bg-red-700 text-white py-2 rounded-lg font-semibold"
        >
          Login Again
        </button>
      </div>
    </div>
  );
};

export default ForceLogoutModal;